// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.tabcontent img {
  width: 100% !important;
  object-fit: contain;
}

@media (max-width: 1200px) {
  .tabcontent {
    width: 80% !important;
    margin: auto;
  }
  .tabcontent .title {
    font-size: 2rem;
    font-weight: 700;
  }
  .tabcontent img {
    width: 100% !important;
    object-fit: contain;
  }
}
/* 先讓桌機/一般裝置的圖片正常自適應 */
.cdetail img {
  max-width: 100% !important;
  height: auto !important;
  display: block;
}

/* 手機版隱藏圖片（含 figure / picture） */
@media (max-width: 768px) {
  .cdetail img,
  .cdetail figure,
  .cdetail picture {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/share/styles/detail.scss"],"names":[],"mappings":"AAAA,gBAAgB;AACZ;EACI,sBAAA;EACA,mBAAA;AACR;;AAEA;EACI;IACI,qBAAA;IACA,YAAA;EACN;EAAM;IACI,eAAA;IACA,gBAAA;EAEV;EAAM;IACI,sBAAA;IACA,mBAAA;EAEV;AACF;AACA,sBAAA;AACA;EACI,0BAAA;EACA,uBAAA;EACA,cAAA;AACJ;;AAEE,gCAAA;AACA;EACE;;;IAGE,wBAAA;EACJ;AACF","sourcesContent":[".tabcontent {\r\n    img {\r\n        width: 100% !important;\r\n        object-fit: contain;\r\n    }\r\n}\r\n@media (max-width:1200px) {\r\n    .tabcontent {\r\n        width: 80%!important;\r\n        margin: auto;\r\n        .title {\r\n            font-size: 2rem;\r\n            font-weight: 700;\r\n        }\r\n        img {\r\n            width: 100% !important;\r\n            object-fit: contain;\r\n        }\r\n    }\r\n}\r\n/* 先讓桌機/一般裝置的圖片正常自適應 */\r\n.cdetail img {\r\n    max-width: 100% !important;\r\n    height: auto !important;\r\n    display: block;\r\n  }\r\n  \r\n  /* 手機版隱藏圖片（含 figure / picture） */\r\n  @media (max-width: 768px) {\r\n    .cdetail img,\r\n    .cdetail figure,\r\n    .cdetail picture {\r\n      display: none !important;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
